import React from "react";
import Select from "react-select";
import { TextField, Dialog, DialogFooter, DialogType, Dropdown, IDropdownOption, Label, PrimaryButton, ResponsiveMode} from "office-ui-fabric-react";
import { blankWordDocumentBase64, fetchContractTempleteData, handleTokenExpiration } from "../Utils/CommonFunctions";
import ContextService from "../services/ContextService";
import { Add20Regular } from "@fluentui/react-icons";
import { SweetAlerts } from "./Global/SweetAlert";
import { useGetSet } from "react-use";
import axios from "axios";

let ContractItems = [];
const ContractTemplate = ({ShowAllContract}) => {
  const FileTemp = localStorage.getItem("ContractTypeRowID");
  const SelectedTemp:any = localStorage.getItem("ContractTemplate");
  const [selectedContract, setSelectedContract] = React.useState<any>();
  const [selectedTemplate, setSelectedTemplate] = useGetSet<IDropdownOption | undefined>(undefined);
  const { SweetAlert: SweetAlertDialog } = SweetAlerts("#SweetalertDialog");
  const [AllConOpt, setAllConOpt] = React.useState([]);
  const [templateName, setTemplateName] = React.useState<any>("");
  const [showTemplate, setShowTemplate] = React.useState(false);

  const dropdownStyles = {
    callout: {
      maxHeight: 200,
      overflowY: "auto",
    },
  };

  const modalProps = {
    isBlocking: true,
    styles: {
      scrollableContent: {
        overflowY: "hidden !important",
      },
      main: {
        fontSize: "18",
        height: 150,
        minHeight: 150,
      },
    },
  };

  const fileDialogContentProps = {
    type: DialogType.normal,
    title: (
      <div  style={{ display: "flex" }}>
        <span style={{fontSize:'16px'}} >{"Add Template"}</span>{" "}
      </div>
    ),
  };

  React.useEffect(() => {
    const fetchData = async () => {
      await getAllContractType();
    };
    fetchData();
  }, []);

  React.useEffect(() => {
    if (AllConOpt?.length && FileTemp) {
      const defaultContract = AllConOpt.find((con) => con?.key === Number(FileTemp));
      const ContractTemp = defaultContract?.ContractTemplate?.filter((template) =>
        template.FileName?.includes(SelectedTemp?.replaceAll(' ','_') || SelectedTemp)).map((template) => ({
        key: template.FileName.replace(/_/g, " "),
        text: template.FileName.replace(/_/g, " "),
        data: template,
      }))[0];
      if (defaultContract) {
        setSelectedContract(defaultContract);
        setSelectedTemplate(ContractTemp);
        getText(ContractTemp?.data?.ServerRelativePath?.["DecodedUrl"], "App");
      }
    }
  }, [AllConOpt, FileTemp]);

  const docxOptions: IDropdownOption[] =
    selectedContract?.ContractTemplate?.filter((template) => template.FileName?.toLowerCase().includes(".docx"))?.map(
      (template) => ({
        key: template.FileName?.replace(/_/g, " "),
        text: template.FileName?.replace(/_/g, " "),
        data: template,
      })
    ) || [];

  const getAllContractType = async () => {
    try {
      const ContractTypes = await fetchContractTempleteData();
      ContractItems = [];
      ContractTypes?.forEach((contract) => {
        ContractItems.push({
          key: contract.Id,
          text: contract?.ContractName,
          value: contract?.ContractName,
          label: contract?.ContractName,
          ContractCode: contract?.ContractCode,
          ContractTemplate: contract?.AttachmentFiles,
        });
      });
      setAllConOpt(ContractItems?.sort((a, b) => a?.label.localeCompare(b?.label)));
    } catch (error) {
      console.log(error);
    }
  };

  const handleChange = async (option): Promise<void> => {
    const selected = option;
    setSelectedContract(selected);
    localStorage.setItem("ContractTypeRowID", selected?.key);
    localStorage.setItem("ContractTemplate", selected?.ContractTemplate[0]?.FileName);
    localStorage.setItem("ContractTypeFileName",selected?.ContractTemplate[0]?.FileName);
    await getText(selected?.ContractTemplate[0]?.ServerRelativePath?.DecodedUrl, "Change");
  };

  const handleTemplateChange = async (_: React.FormEvent<HTMLDivElement>, option: any): Promise<void> => {
    // console.log(event);
    setSelectedTemplate(option);
    localStorage.setItem("ContractTemplate", option?.key);
    localStorage.setItem("ContractTypeFileName",option?.key);
    await getText(option?.data?.ServerRelativePath?.["DecodedUrl"], "Change");
  };

  const _onChangeFileName = (_: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
    // console.log(event);
    setTemplateName(newValue);
    localStorage.setItem("ContractTypeFileName", newValue?.concat(".docx"));
  };

  async function getText(ServerRelativeUrl, process) {
    const filePath = encodeURIComponent(ServerRelativeUrl);
    const curl = `${ContextService.GetUrl()}/_api/web/getfilebyserverrelativeurl('${filePath}')/$value`;
    try {
      const token = localStorage.getItem("CurrentToken");
      const responseBlob: any = await axios({
        method: "get",
        url: curl,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob",
      });

      if (responseBlob?.data) {
        const fileData = new File([responseBlob?.data], "template.docx", {
          type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        });
        if (process === "Change") {
          await insertFileIntoWord(fileData);
        }
      }
    } catch (error) {
       const status = error?.response?.status;
      if ([401, 402, 403].includes(status)) {
      return await handleTokenExpiration( getText(ServerRelativeUrl, process));
    } else {
      console.log(error);
    }
   }
  }

  const insertFileIntoWord = async (file) => {
    try {
      await Word.run(async (context) => {
        const reader = new FileReader();

        reader.onload = async (event) => {
          const arrayBuffer = event.target.result;
          const base64String = arrayBufferToBase64(arrayBuffer);
          context.document.body.insertFileFromBase64(base64String, Word.InsertLocation.replace);
          await context.sync();
        };
        reader.readAsArrayBuffer(file);
        // console.log(file, "file");
      });
    } catch (error) {
      console.error("Error inserting Word file:", error);
    }
  };

  const arrayBufferToBase64 = (buffer) => {
    let binary = "";
    const bytes = new Uint8Array(buffer);
    bytes.forEach((byte) => (binary += String.fromCharCode(byte)));
    return btoa(binary);
  };

  async function createAndOpenBlankDocument() {
   const tempExist = selectedContract?.ContractTemplate?.some(template =>
      template.FileName.includes(templateName?.replaceAll(' ','_')?.concat(".docx"))
    )
    if(!templateName?.trim()){
      SweetAlertDialog('error','Please enter template name')
    } else if(tempExist){
      SweetAlertDialog('error','Template name already exist')
    } else {
    setShowTemplate(false);
    setTemplateName('');
    const token = localStorage.getItem("CurrentToken");
    const siteUrl = localStorage.getItem("SiteURL");
    const libraryName = "CLM365RequestDraft";
    const parentFolder = "Temporary Contract Type";
    const targetFolderName = `rowID_${selectedContract?.key}`;
    const fileName = templateName.concat(".docx");

    const headers = {
      Authorization: `Bearer ${token}`,
      Accept: "application/json;odata=verbose",
      "Content-Type": "application/json;odata=verbose",
    };

    try {
      const ensureFolderUrl = `${siteUrl}/_api/web/GetFolderByServerRelativeUrl('${libraryName}/${parentFolder}')/Folders`;
      await axios
        .post(
          ensureFolderUrl,
          JSON.stringify({
            __metadata: { type: "SP.Folder" },
            ServerRelativeUrl: `${libraryName}/${parentFolder}/${targetFolderName}`,
          }),
          { headers }
        )
        .catch((err) => {
          if (err.response?.status !== 500) console.error("Folder creation error:", err);
        });

      const Blob1 = fetch(blankWordDocumentBase64).then((res) => res.blob());

      Promise.all([Blob1]).then(async ([docBlob]) => {
        const uploadUrl = `${siteUrl}/_api/web/GetFolderByServerRelativeUrl('${libraryName}/${parentFolder}/${targetFolderName}')/Files/add(url='${fileName}', overwrite=true)`;
        await axios.post(uploadUrl, docBlob, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json;odata=verbose",
            "Content-Type": "application/octet-stream",
          },
        });
      });
      await uploadAttachment(fileName)
      await new Promise((resolve) => setTimeout(resolve, 1000));
      const sitePath = siteUrl.split(".com")[1];
      const fileRelativeUrl = `${sitePath}/${libraryName}/${parentFolder}/${targetFolderName}/${fileName}`;
      const fileMetaUrl = `${siteUrl}/_api/web/GetFileByServerRelativeUrl('${fileRelativeUrl}')/ListItemAllFields?$select=ServerRedirectedEmbedUri`;

      const fileItemRes = await axios.get(fileMetaUrl, { headers });
      const redirectUrl = fileItemRes.data?.d?.ServerRedirectedEmbedUri;

      if (redirectUrl) {
        const finalUrl = redirectUrl.replace("=interactivepreview", "=edit") + `&ContractTypeID=${selectedContract?.key}&Comp=contractType`;
        window.open(finalUrl, "_blank");
      } else {
        console.log("Could not retrieve document link.");
      }
    } catch (error) {
      console.error("Error creating or opening document:", error);
    }
  }
}
async function uploadAttachment(filename) {
  const siteUrl = localStorage.getItem("SiteURL");
  const accessToken = localStorage.getItem("CurrentToken");

  try {
    const blobResponse = await fetch(blankWordDocumentBase64);
    const blob = await blobResponse.blob();

    const arrayBuffer = await blob.arrayBuffer();

    const uploadUrl = `${siteUrl}/_api/web/lists/getbytitle('CLM365Contract_Type')/items(${selectedContract?.key})/AttachmentFiles/add(FileName='${filename?.replaceAll(' ','_')}')`;

    const response = await axios.post(uploadUrl, arrayBuffer, {
      headers: {
        "Authorization": `Bearer ${accessToken}`,
        "Accept": "application/json;odata=verbose",
        "Content-Type": "application/octet-stream"
      }
    });
    localStorage.setItem("ContractTemplate", filename);
    // console.log('Attachment uploaded');
  } catch (error) {
    console.error("Error uploading attachment:", error);
  }
}

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "10px", marginBottom: "20px", marginTop: !ShowAllContract ? '-10px' : '' }}>
      <div>
        {ShowAllContract && <><Label>Contract Template:</Label>
        <Select
          options={AllConOpt}
          value={selectedContract}
          onChange={(option) => handleChange(option)}
          placeholder="Select a contract type..."
        /></>}
      </div>
      <div style={{paddingTop: !ShowAllContract ? '7px' : ''}}>
      <div style={{marginBottom: '6px'}}>
        <strong style={{display: 'inline-block', width:'36%'}}>Title</strong>
        <span title= {selectedContract?.label} className='RequestDetails'>{selectedContract?.label}</span>
      </div>
      <div>
        <strong style={{display: 'inline-block', width:'36%'}}>Contract Code</strong>
        <span title= {selectedContract?.ContractCode} className='RequestDetails'>{selectedContract?.ContractCode}</span>
      </div>
      </div>
      {docxOptions.length > 0 && (
        <Dropdown
          label="Template File(s)"
          placeholder="Select a template file"
          options={docxOptions}
          selectedKey={selectedTemplate()?.key}
          styles={dropdownStyles}
          responsiveMode={ResponsiveMode.large}
          onChange={handleTemplateChange}
        />
      )}
      <div
        style={{ display: "flex", alignItems: "center", gap: "3px", cursor: "pointer" }}
        onClick={() => setShowTemplate(true)}>
        <Add20Regular />
        <Label>Add Template</Label>
      </div>
      {showTemplate && (
        <Dialog
          hidden={!showTemplate}
          onDismiss={() => { setShowTemplate(false), setTemplateName("")}}
          dialogContentProps={fileDialogContentProps}
          modalProps={modalProps}>
          <div id="SweetalertDialog">
            <TextField
              value={templateName}
              onChange={_onChangeFileName}
              placeholder={"Enter template name"}>
            </TextField>
            <DialogFooter styles={{ actionsRight: { justifyContent: "center", display: "flex", width: "100%" } }}>
              <PrimaryButton onClick={createAndOpenBlankDocument} text={"Next"} />
            </DialogFooter>
          </div>
        </Dialog>
      )}
    </div>
  );
};

export default ContractTemplate;
